import { getActivityTime } from '../helpers/userActivityHelpers.js';
export class heartbeatRepository {
    static async sendHeartBeat(heartbeatUrl, accessToken) {
        const headers = {
            'Content-Type': 'application/json',
        };
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`;
        }
        try {
            const response = await fetch(`${heartbeatUrl}?lastRecordedActivity=${getActivityTime()}`, {
                method: 'POST',
                headers,
            });
            return response;
        }
        catch (error) {
            console.error(error);
            return null;
        }
    }
}
